import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'src/features';
import { FortunePageLayout } from '../../common/FortunePageLayout';
import { FortuneItemDetailContent } from './FortuneItemDetailContent';

export const FortuneExchangeableItemDetail: React.FC = () => {
  const { t } = useTranslation(['fortune', 'translation']);
  const params = useParams<{ id: string }>();
  const { point, exchangeableItem } = useSelector((state: RootState) => state.fortune);

  const uniqueId = getUniqueIdAsNum(params.id);

  if (point?.state !== 'ok' || exchangeableItem?.state !== 'ok' || uniqueId === undefined) {
    return null;
  }

  const found = exchangeableItem.result.items.find(item => item.unique_id === uniqueId);
  if (!found) {
    return null;
  }

  const topColor = '#f4ffe0';
  const bottomColor = '#dff4b6';

  return (
    <FortunePageLayout
      title={t('exchange_items')}
      backLabel={t('translation:aria_button_back_to_previous')}
      background={`linear-gradient(to bottom, ${topColor} 0%, ${topColor} 45%, ${bottomColor} 55%, ${bottomColor} 100%)`}
    >
      <FortuneItemDetailContent item={found} ownedPoint={point.result.currentPoint} />
    </FortunePageLayout>
  );
};

// helper function
function getUniqueIdAsNum(numStr: string) {
  const parsed = parseInt(numStr, 10);

  if (isNaN(parsed)) {
    return undefined;
  }
  return parsed;
}
